import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyNullResponse } from 'src/app/shared/models/responses/body-null-response.model';
import { environment } from 'src/environments/environment';
import { FinallCreateJobOffer } from 'src/app/shared/models/dashboard/job-offer/finall-job-offer.model';
import { JobOfferResponse } from 'src/app/shared/models/responses/job-offer-response.model';
import { FinalCandidateHRCvrModel } from '../../../../../../libs/shared/src/lib/models/dashboard';
import { NotesModel } from 'src/app/shared/models/dashboard/candidate-detail/notes.model';
import { NotesBEModel } from 'src/app/shared/models/dashboard/candidate-detail/notes-be.model';
import { FinallFirmRegisterModel } from 'src/app/shared/models/firm-register/firm-register-final.model';
import { UserFromBE, FinallUserInvitationsModel, FinallUserResendInvitationsModel, ChangePassword, UpdatePersonalInfoModel, Role } from '@sameta/shared';
import { BodyAttachmentResponse } from 'src/app/shared/models/responses/body-attachment-response.model';
import { CreateWatcherRequestData, EntityTypeEnum, GetWatchersRequestData } from '../../shared/models/dashboard/watchers/watchers.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  createCVHR = 'create-cv-hr';
  updateCVHR = 'update-hr-cv';
  getCandidateDetailByIdURL = 'get-hr-cv-id';
  getUserDetailByIdURL = 'get-user-cv-id';
  updateCandidateStatusURL = 'update-hr-cv-status';
  deleteAssociateCandidateURL = 'delete-associations-hr-cv';
  deleteItemURL = 'delete-item-job-offer';
  getJobOfferByIdURL = 'get-job-offer-id';
  getAttachmentsByIdURL = 'api/get-attachments';
  deleteAttachmentURL = 'api/delete-hr-attachment';
  getJobOfferByCandidateURL = 'get-job-offer-candidate';
  getCandidateByJobOfferURL = 'get-candidate-job-offer';
  createNoteURL = 'create-note';
  getNotesIDURL = 'get-notes-id';
  getNotesURL = 'get-notes';
  updateNotesURL = 'update-notes';
  deleteNotesURL = 'delete-notes';
  getJobOffersURL = 'job-offers';
  getCandidatesURL = 'api/hr/cv-list';
  unanonymizeCandidateURL = 'api/hr/candidates';
  openapiGetAuditURL = 'api/get-audit-logs';
  openapiGetCandidateAuditUuidURL = 'api/get-candidate-audit-logs-uuid';
  openapiGetCsvAuditURL = 'api/get-csv-audit-logs';
  openapiGetCsvAuditUUIDURL = 'api/get-csv-audit-logs-uuid';
  createJobOffer = 'create-job-offer';
  editJobOffer = 'update-job-offer';
  getEditJobOffer = 'get-job-offer-id';
  getEditJobOfferToEdit = 'get-job-offer-id-to-edit';
  updateJobOfferStatusURL = 'update-job-offer-status';
  assignJobToCandidateURL = 'assign-job';
  assignJobToRecommendedUserURL = 'assign-job-to-recommended-user';
  deleteJobFromCandidateURL = 'delete-assigned-job';
  getAssignedJobsAndCandidatesURL = 'get-candidates-to-job-offers';
  getCandidateJobRelationsUuidURL = 'candidate-job-relations-uuid';
  getCompanyDataByIdURL = 'get-tenant-id';
  updateCompanyURL = 'update-tenant';
  sendInvitation = 'send-invitations';
  updateUserRoleURL = 'update-user-role';
  resendInvitationURL = 'resend-invitation';
  getTenantUsersURL = 'get-tenant-users';
  updateTenantsUserStatusURL = 'update-tenant-user-status';
  deleteTenantsUserURL = 'delete-tenant-user';
  resendInvitationFOrTenantsUserURL = 'resend-invitation-for-tenant-user';
  hrDashboardURL = 'dashboard';
  hrDashboarDiversitydURL = 'dashboard-diversity';
  hrDashboarAverageURL = 'average-time-to-hire';
  getStatusesToJobsURL = 'get-statuses-to-jobs';
  getUserDataURL = 'get-user-data';
  updateUserURL = 'update-hr-user';
  updateUserPassword = 'api/change-password';
  getWatchersURL = 'api/get-watchers';
  createWatcherURL = 'api/create-watcher';
  removeWatcherURL = 'api/remove-watcher';
  getTenantUsersOAPI = 'api/get-tenant-users';
  createNoteURLOAPI = 'api/create-note';
  getNotesIDURLOAPI = 'api/get-note';
  getNotesURLOAPI = 'api/get-notes';
  updateNotesURLOAPI = 'api/update-note';
  deleteNotesURLOAPI = 'api/delete-note';
  changeJobOwnerURL = 'api/change-job-owner';
  jobPositionsURL = 'api/get-job-position';
  jobCategoriesURL = 'api/get-categories';
  getRankedCandidatesURL = 'api/ranked-candidates';

  constructor(private http: HttpClient) {}

  private getHTTPHeaders(): HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json');
  }

  getJobPositions(id: number): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('jobCategoryId', id);
    return this.http.get<any>(environment.openApiUrl + this.jobPositionsURL, { params: queryParams });
  }

  getCategories(): Observable<any> {
    return this.http.get<any>(environment.openApiUrl + this.jobCategoriesURL);
  }

  getJobCreationOptions(): Observable<any> {
    return this.http.get<any>(environment.openApiUrl + 'api/get-job-creation-options');
  }

  getJobOffers(
    limit?: string,
    offset?: string,
    dateFrom?: string,
    dateTo?: string,
    filter?: string,
    statuses?: string,
    sort?: string,
    sortColumn?: string,
    blacklist?: string[]
  ): Observable<any> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append('dateTo', dateTo ? dateTo : '');
    queryParams = queryParams.append('dateFrom', dateFrom ? dateFrom : '');
    queryParams = queryParams.append('filter', filter ? filter : '');
    queryParams = queryParams.append('limit', limit ? limit : '');
    queryParams = queryParams.append('offset', offset ? offset : '');
    queryParams = queryParams.append('statuses', statuses ? statuses : '');
    queryParams = queryParams.append('sort', sort ? sort : '');
    queryParams = queryParams.append('sortColumn', sortColumn ? sortColumn : '');
    queryParams = queryParams.append('blacklist', JSON.stringify(blacklist));

    return this.http.get<any>(environment.apiUrl + this.getJobOffersURL, { params: queryParams });
  }

  getCandidates(
    limit?: string,
    offset?: string,
    dateFrom?: string,
    dateTo?: string,
    filter?: string,
    statuses?: string,
    sort?: string,
    sortColumn?: string,
    blacklist?: string[],
    jobDetail = false
  ): Observable<any> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append('dateTo', dateTo ? dateTo : '');
    queryParams = queryParams.append('dateFrom', dateFrom ? dateFrom : '');
    queryParams = queryParams.append('filter', filter ? filter : '');
    queryParams = queryParams.append('limit', limit ? limit : '');
    queryParams = queryParams.append('offset', offset ? offset : '');
    queryParams = queryParams.append('statuses', statuses ? statuses : '');
    queryParams = queryParams.append('sort', sort ? sort : 'asc');
    queryParams = queryParams.append('sortColumn', sortColumn ? sortColumn : 'id');
    queryParams = queryParams.append('blacklist', JSON.stringify(blacklist));
    if (jobDetail) {
      queryParams = queryParams.append('jobDetail', jobDetail);
    }

    return this.http.get<any>(environment.openApiUrl + this.getCandidatesURL, { params: queryParams });
  }

  sendNewJobOfferData(data: FinallCreateJobOffer): Observable<BodyNullResponse> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.post<BodyNullResponse>(environment.apiUrl + this.createJobOffer, JSON.stringify(data), { headers: httpHeaders });
  }

  sendEditJobOfferData(data: any, group: string, id: number | string): Observable<BodyNullResponse> {
    const httpHeaders = this.getHTTPHeaders();
    let queryParams = new HttpParams();

    queryParams = queryParams.append('group', group);
    queryParams = queryParams.append('id', id);
    return this.http.put<BodyNullResponse>(environment.apiUrl + this.editJobOffer, JSON.stringify(data), { headers: httpHeaders, params: queryParams });
  }

  getEditJobOfferDataByID(id?: number): Observable<JobOfferResponse> {
    let queryParams = new HttpParams();
    const httpHeaders = this.getHTTPHeaders();
    queryParams = queryParams.append('id', id ? id.toString() : '');

    return this.http.get<JobOfferResponse>(environment.apiUrl + this.getEditJobOfferToEdit, {
      params: queryParams,
    });
  }

  assignJobToCandidate(candidateId?: string, jobId?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('candidateId', candidateId ? candidateId : '');
    queryParams = queryParams.append('jobId', jobId ? jobId : '');

    return this.http.get<any>(environment.apiUrl + this.assignJobToCandidateURL, {
      params: queryParams,
    });
  }

  assignJobToRecommendedUser(userUUID?: string, jobId?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('userUUID', userUUID || '');
    queryParams = queryParams.append('jobId', jobId || '');

    return this.http.get<any>(environment.apiUrl + this.assignJobToRecommendedUserURL, {
      params: queryParams,
    });
  }

  changeJobOwner(jobId: string, userId: string, isAdmin: boolean): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('jobId', jobId);
    queryParams = queryParams.append('userId', userId);
    queryParams = queryParams.append('isAdmin', isAdmin);
    return this.http.get<any>(environment.openApiUrl + this.changeJobOwnerURL, {
      params: queryParams,
    });
  }

  deleteAssignedJobFromCandidate(candidateId?: string, jobId?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('candidateId', candidateId ? candidateId : '');
    queryParams = queryParams.append('jobId', jobId ? jobId : '');

    return this.http.get<any>(environment.apiUrl + this.deleteJobFromCandidateURL, {
      params: queryParams,
    });
  }

  deleteAttachment(attachmentId: string): Observable<any> {
    return this.http.delete<any>(environment.openApiUrl + this.deleteAttachmentURL, {
      body: { attachmentId: Number(attachmentId) },
    });
  }

  getJobOfferById(id?: number): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id ? id : '');

    return this.http.get<any>(environment.apiUrl + this.getJobOfferByIdURL, {
      params: queryParams,
    });
  }

  getAttachmentsByJobId(model: string, id: string): Observable<BodyAttachmentResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('entityId', id);
    queryParams = queryParams.append('entityModel', model);

    return this.http.get<BodyAttachmentResponse>(environment.openApiUrl + this.getAttachmentsByIdURL, {
      params: queryParams,
    });
  }

  updateJobOfferStatusById(id?: number, status?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id ? id : '');
    queryParams = queryParams.append('status', status ? status : '');

    return this.http.get<any>(environment.apiUrl + this.updateJobOfferStatusURL, {
      params: queryParams,
    });
  }

  updateCandidateStatusById(uuid?: string, status?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('uuid', uuid ? uuid : '');
    queryParams = queryParams.append('status', status ? status : '');

    return this.http.get<any>(environment.apiUrl + this.updateCandidateStatusURL, {
      params: queryParams,
    });
  }

  createNewCandidateCVHR(data: FinalCandidateHRCvrModel): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.post<any>(environment.apiUrl + this.createCVHR, JSON.stringify(data), { headers: httpHeaders });
  }

  getCandidateDetailById(uuid?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('uuid', uuid ? uuid : '');

    return this.http.get<any>(environment.apiUrl + this.getCandidateDetailByIdURL, {
      params: queryParams,
    });
  }

  /**
   * Get user CV data by UUID (for recommended candidates view)
   * Returns user with longcv relationship data
   */
  getUserCvByUuid(uuid: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('uuid', uuid);

    return this.http.get<any>(environment.apiUrl + this.getUserDetailByIdURL, { params: queryParams });
  }

  sendEditCandidateData(data: FinalCandidateHRCvrModel): Observable<BodyNullResponse> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.put<BodyNullResponse>(environment.apiUrl + this.updateCVHR, data, { headers: httpHeaders });
  }

  createNewNote(data: NotesModel): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.post<any>(environment.openApiUrl + this.createNoteURLOAPI, JSON.stringify(data), { headers: httpHeaders });
  }

  getAllNotes(limit?: string, offset?: string, entityID?: string, entityType?: string, dateFrom?: string, dateTo?: string, filter?: string): Observable<any> {
    let queryParams = new HttpParams();

    if (limit) queryParams = queryParams.append('limit', limit);
    if (offset) queryParams = queryParams.append('offset', offset);
    if (dateFrom) queryParams = queryParams.append('dateFrom', dateFrom);
    if (dateTo) queryParams = queryParams.append('dateTo', dateTo);
    if (filter) queryParams = queryParams.append('filter', filter);
    queryParams = queryParams.append('entityID', entityID ? entityID : '');
    queryParams = queryParams.append('entityType', entityType ? entityType : '');

    return this.http.get<any>(environment.openApiUrl + this.getNotesURLOAPI, { params: queryParams });
  }

  getCandidateNoteById(id?: number): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('noteID', id ? id : '');

    return this.http.get<any>(environment.openApiUrl + this.getNotesIDURLOAPI, {
      params: queryParams,
    });
  }

  updateNote(id: number, note: string): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.put<any>(environment.openApiUrl + this.updateNotesURLOAPI, JSON.stringify({ id, note }), { headers: httpHeaders });
  }

  deleteNote(id: number): Observable<any> {
    return this.http.delete<any>(environment.openApiUrl + this.deleteNotesURLOAPI, { body: { id } });
  }

  sendInvitaions(data: FinallUserInvitationsModel): Observable<BodyNullResponse> {
    const httpHeaders = this.getHTTPHeaders();
    let queryParams = new HttpParams();
    queryParams = queryParams.append('email', data ? data.email : '');
    queryParams = queryParams.append('role', data ? data.role : '');
    queryParams = queryParams.append('language', data ? data.language : '');
    return this.http.post<BodyNullResponse>(environment.apiUrl + this.sendInvitation, JSON.stringify(data), { headers: httpHeaders, params: queryParams });
  }

  updateUserRole(roleIdFrom: number, roleIdTo: number, data: UserFromBE): Observable<BodyNullResponse> {
    const httpHeaders = this.getHTTPHeaders();
    let queryParams = new HttpParams();
    queryParams = queryParams.append('userId', data ? data.id : '');
    queryParams = queryParams.append('roleIdTo', data ? roleIdTo : '');
    queryParams = queryParams.append('roleIdFrom', data ? roleIdFrom : '');

    return this.http.put<BodyNullResponse>(environment.apiUrl + this.updateUserRoleURL, JSON.stringify(data), {
      headers: httpHeaders,
      params: queryParams,
    });
  }

  getTenantUsers(registered = false): Observable<BodyNullResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('justRegistered', registered);
    return this.http.get<BodyNullResponse>(environment.openApiUrl + this.getTenantUsersOAPI, { params: queryParams });
  }

  updateTenantsUserStatusById(id?: number, status?: string): Observable<BodyNullResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id ? id : '');
    queryParams = queryParams.append('status', status ? status : '');

    return this.http.get<BodyNullResponse>(environment.apiUrl + this.updateTenantsUserStatusURL, {
      params: queryParams,
    });
  }

  deleteTenantsUserById(id: number): Observable<BodyNullResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id ? id : '');
    return this.http.delete<BodyNullResponse>(environment.apiUrl + this.deleteTenantsUserURL, {
      params: queryParams,
    });
  }

  resendInvitaionForTenantUser(data: FinallUserResendInvitationsModel): Observable<BodyNullResponse> {
    const httpHeaders = this.getHTTPHeaders();
    let queryParams = new HttpParams();
    queryParams = queryParams.append('email', data ? data.email : '');
    queryParams = queryParams.append('inviteHash', data ? data.inviteHash : '');
    queryParams = queryParams.append('language', data ? data.language : '');
    return this.http.post<BodyNullResponse>(environment.apiUrl + this.resendInvitationURL, JSON.stringify(data), { headers: httpHeaders, params: queryParams });
  }

  getAudit(
    limit?: string,
    offset?: string,
    dateFrom?: string,
    dateTo?: string,
    userIDs?: string,
    entityIDs?: string,
    auditType?: string,
    auditModel?: string,
    tenantID?: string
  ): Observable<any> {
    let queryParams = new HttpParams();
    if (dateFrom != null) {
      queryParams = queryParams.append('dateFrom', dateFrom);
    }
    if (dateTo != null) {
      queryParams = queryParams.append('dateTo', dateTo);
    }
    queryParams = queryParams.append('entityIDs', entityIDs ? entityIDs : '');
    queryParams = queryParams.append('auditType', auditType ? auditType : '');
    queryParams = queryParams.append('auditModel', auditModel ? auditModel : '');
    queryParams = queryParams.append('tenantID', tenantID ? tenantID : '');

    // Ensure limit and offset are always passed as numbers
    const limitValue = limit && limit !== '' ? limit : '5';
    const offsetValue = offset && offset !== '' ? offset : '0';
    queryParams = queryParams.append('limit', limitValue);
    queryParams = queryParams.append('offset', offsetValue);
    return this.http.get<any>(environment.openApiUrl + this.openapiGetAuditURL, { params: queryParams });
  }

  getCandidateAuditByUUID(
    limit?: string,
    offset?: string,
    dateFrom?: string,
    dateTo?: string,
    userIDs?: string,
    entityUUIDs?: string,
    auditType?: string,
    auditModel?: string,
    tenantID?: string
  ): Observable<any> {
    let queryParams = new HttpParams();
    if (dateFrom != null) {
      queryParams = queryParams.append('dateFrom', dateFrom);
    }
    if (dateTo != null) {
      queryParams = queryParams.append('dateTo', dateTo);
    }
    queryParams = queryParams.append('entityIDs', entityUUIDs ? entityUUIDs : '');
    queryParams = queryParams.append('auditType', auditType ? auditType : '');
    queryParams = queryParams.append('auditModel', auditModel ? auditModel : '');
    queryParams = queryParams.append('tenantID', tenantID ? tenantID : '');

    // Ensure limit and offset are always passed as numbers
    const limitValue = limit && limit !== '' ? limit : '5';
    const offsetValue = offset && offset !== '' ? offset : '0';
    queryParams = queryParams.append('limit', limitValue);
    queryParams = queryParams.append('offset', offsetValue);
    return this.http.get<any>(environment.openApiUrl + this.openapiGetCandidateAuditUuidURL, { params: queryParams });
  }

  getCsvAudit(
    logType: string,
    limit?: string,
    offset?: string,
    dateFrom?: string,
    dateTo?: string,
    userIDs?: string,
    entityIDs?: string,
    auditType?: string,
    auditModel?: string,
    tenantID?: string
  ): Observable<Blob> {
    let queryParams = new HttpParams();
    if (dateFrom != null) {
      queryParams = queryParams.append('dateFrom', dateFrom);
    }
    if (dateTo != null) {
      queryParams = queryParams.append('dateTo', dateTo);
    }
    queryParams = queryParams.append('entityIDs', entityIDs ? entityIDs : '');
    queryParams = queryParams.append('auditType', auditType ? auditType : '');
    queryParams = queryParams.append('auditModel', auditModel ? auditModel : '');
    queryParams = queryParams.append('tenantID', tenantID ? tenantID : '');

    return this.http.get(environment.openApiUrl + (logType == 'cv' ? this.openapiGetCsvAuditUUIDURL : this.openapiGetCsvAuditURL), {
      params: queryParams,
      responseType: 'blob',
    });
  }

  deleteAssociateCandidate(childID: number, associationType: string): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + this.deleteAssociateCandidateURL, {
      body: {
        childID,
        associationType,
      },
    });
  }

  getAssignedCandidatesAndJobs(jobOfferId?: string, candidateId?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('jobOfferId', jobOfferId ? jobOfferId : '');
    queryParams = queryParams.append('candidateId', candidateId ? candidateId : '');

    return this.http.get<any>(environment.apiUrl + this.getAssignedJobsAndCandidatesURL, { params: queryParams });
  }

  getCandidateJobRelationsByUUID(jobOfferId?: string, candidateUuid?: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('jobOfferId', jobOfferId ? jobOfferId : '');
    queryParams = queryParams.append('candidateUuid', candidateUuid ? candidateUuid : '');

    return this.http.get<any>(environment.apiUrl + this.getCandidateJobRelationsUuidURL, { params: queryParams });
  }

  getCompanyDataById(id: string): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id ? id : '0');

    return this.http.get<any>(environment.apiUrl + this.getCompanyDataByIdURL, {
      params: queryParams,
    });
  }

  updateCompany(data: FinallFirmRegisterModel): Observable<FinallFirmRegisterModel> {
    const companyUpdate = new FinallFirmRegisterModel();
    companyUpdate.id = data.id;
    companyUpdate.createdAt = data.createdAt;
    companyUpdate.deletedAt = data.deletedAt;
    companyUpdate.name = data.name;
    companyUpdate.logo = data.logo;
    companyUpdate.active = data.active;
    companyUpdate.tenantType = data.tenantType;
    companyUpdate.companyID = data.companyID;
    companyUpdate.taxID = data.taxID;
    companyUpdate.vat = data.vat;
    companyUpdate.inRegister = data.inRegister;
    companyUpdate.companyRepresentativeName = data.companyRepresentativeName;
    companyUpdate.companyRepresentativeEmail = data.companyRepresentativeEmail;
    companyUpdate.employeesNumber = data.employeesNumber;
    companyUpdate.tenantCharacteristic = data.tenantCharacteristic;
    companyUpdate.tenantBenefits = data.tenantBenefits;
    companyUpdate.tenantAddresses = data.tenantAddresses;
    const httpHeaders = this.getHTTPHeaders();
    return this.http.put<any>(environment.apiUrl + this.updateCompanyURL, JSON.stringify(companyUpdate), { headers: httpHeaders });
  }

  deleteItem(item: string, id: number): Observable<BodyNullResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', id);
    queryParams = queryParams.append('item', item);
    return this.http.delete<any>(environment.apiUrl + this.deleteItemURL, {
      params: queryParams,
    });
  }
  getHrChartsData(dateFrom?: string, dateTo?: string, period?: string): Observable<any> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append('dateTo', dateTo ? dateTo : '');
    queryParams = queryParams.append('dateFrom', dateFrom ? dateFrom : '');
    queryParams = queryParams.append('period', period ? period : '');

    return this.http.get<any>(environment.apiUrl + this.hrDashboardURL, { params: queryParams });
  }

  getHrChartsData2(dateFrom?: string, dateTo?: string, period?: string): Observable<any> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append('dateTo', dateTo ? dateTo : '');
    queryParams = queryParams.append('dateFrom', dateFrom ? dateFrom : '');
    queryParams = queryParams.append('period', period ? period : '');

    return this.http.get<any>(environment.apiUrl + 'dashboard-statuses-to-jobs', { params: queryParams });
  }

  getHrDiversityChartsData(dateFrom?: string, dateTo?: string, period?: string): Observable<any> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append('dateTo', dateTo ? dateTo : '');
    queryParams = queryParams.append('dateFrom', dateFrom ? dateFrom : '');
    queryParams = queryParams.append('period', period ? period : '');

    return this.http.get<any>(environment.apiUrl + this.hrDashboarDiversitydURL, { params: queryParams });
  }

  getHrAverageChartsData(dateFrom?: string, dateTo?: string, period?: string): Observable<any> {
    let queryParams = new HttpParams();

    queryParams = queryParams.append('dateTo', dateTo ? dateTo : '');
    queryParams = queryParams.append('dateFrom', dateFrom ? dateFrom : '');

    return this.http.get<any>(environment.apiUrl + this.hrDashboarAverageURL, { params: queryParams });
  }

  getHrStatusesToJobsData(): Observable<any> {
    let queryParams = new HttpParams();

    return this.http.get<any>(environment.apiUrl + this.getStatusesToJobsURL, { params: queryParams });
  }

  getUserData(): Observable<any> {
    let queryParams = new HttpParams();
    return this.http.get<any>(environment.apiUrl + this.getUserDataURL, { params: queryParams });
  }

  updateUser(data: UserFromBE): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.put<any>(environment.apiUrl + this.updateUserURL, JSON.stringify(data), { headers: httpHeaders });
  }

  changePassword(data: ChangePassword): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.put<any>(environment.openApiUrl + this.updateUserPassword, JSON.stringify(data), { headers: httpHeaders });
  }

  getWatchers(data: GetWatchersRequestData): Observable<any> {
    const { entityId, entityType } = data;
    let queryParams = new HttpParams();
    queryParams = queryParams.append('entity_id', entityId);
    queryParams = queryParams.append('entity_type', entityType);

    const httpHeaders = this.getHTTPHeaders();
    return this.http.get<any>(environment.openApiUrl + this.getWatchersURL, { headers: httpHeaders, params: queryParams });
  }

  removeWatcher(watcherId: number): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.put<any>(environment.openApiUrl + this.removeWatcherURL, JSON.stringify({ watcher_id: watcherId }), { headers: httpHeaders });
  }

  createWatcher(data: CreateWatcherRequestData): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    return this.http.post<any>(environment.openApiUrl + this.createWatcherURL, JSON.stringify(data), { headers: httpHeaders });
  }

  /**
   * Reveals an anonymized candidate by consuming an anonymization token
   * @param candidateUuid UUID of the candidate to reveal
   * @returns Observable with the revealed candidate data
   */
  unanonymizeCandidate(candidateUuid: string): Observable<any> {
    const httpHeaders = this.getHTTPHeaders();
    const url = `${environment.openApiUrl}${this.unanonymizeCandidateURL}/${candidateUuid}/unanonymize`;

    return this.http.post<any>(url, {}, { headers: httpHeaders });
  }

  /**
   * Get ranked candidates with match scores for a job offer
   * This mirrors the functionality from the sameta-fe-jobs template
   */
  getRankedCandidates(jobOfferId: string, provider: string = 'openai'): Observable<any> {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('job_offer_id', jobOfferId);
    queryParams = queryParams.append('provider', provider);

    // Use openApiUrl for the ranked-candidates endpoint since it's likely a newer API
    return this.http.get<any>(environment.openApiUrl + this.getRankedCandidatesURL, { params: queryParams });
  }
}
